import { render, staticRenderFns } from "./StepStatusSwitch.vue?vue&type=template&id=35e5cfc2&scoped=true"
import script from "./StepStatusSwitch.vue?vue&type=script&lang=js"
export * from "./StepStatusSwitch.vue?vue&type=script&lang=js"
import style0 from "./StepStatusSwitch.vue?vue&type=style&index=0&id=35e5cfc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5cfc2",
  null
  
)

export default component.exports